import { createAsyncThunk } from '@reduxjs/toolkit';
import { SecureClient, debug } from '../../../utils';
import {
  OTP_FOR_CURR_ADD_CHANGE,
  OTP_FOR_EMAIL_CHANGE,
  OTP_FOR_MOB_CHANGE,
  OTP_FOR_OFFICE_ADD_CHANGE,
  OTP_FOR_BANK_DET_CHANGE,
  APP_ID,
  APP_VERSION,
} from '../../../utils/constants/index';

export const SubmitProfileDetailsApi = createAsyncThunk(
  'SubmitProfile',
  async (submitProfilePayload, { dispatch }) => {
    dispatch({ type: 'SubmitProfile/pending', payload: {} });

    const {
      customerId,
      Authorization,
      customerRefNum,
      type,
      templateType,
      otpCode,
    } = submitProfilePayload;
    let profileDataModel;

    if (templateType === OTP_FOR_CURR_ADD_CHANGE) {
      const { addressDetails } = submitProfilePayload;
      const { addressLine1, addressLine2, city, state, pincode, landmark } =
        addressDetails;
      profileDataModel = {
        addressDetails: {
          addressLine1,
          addressLine2,
          landmark,
          city,
          state,
          pincode,
        },
        type,
      };
    } else if (templateType === OTP_FOR_OFFICE_ADD_CHANGE) {
      const { companyDetails } = submitProfilePayload;
      const {
        companyName,
        officeArea,
        officeCity,
        officeState,
        officePincode,
        officeLandmark,
      } = companyDetails;
      profileDataModel = {
        companyDetails: {
          companyName,
          officeArea,
          landmark: officeLandmark,
          officeCity,
          officeState,
          officePincode,
        },
        type,
      };
    } else if (templateType === OTP_FOR_BANK_DET_CHANGE) {
      const { bankDetails } = submitProfilePayload;
      const { accountNumber, ifscCode, bankName, bankBranch } = bankDetails;
      profileDataModel = {
        bankDetails: {
          accountNumber,
          ifscCode,
          bankName,
          bankBranch,
        },
        type,
      };
    } else if (templateType === OTP_FOR_EMAIL_CHANGE) {
      const { contactDetails } = submitProfilePayload;
      const { emailId } = contactDetails;
      profileDataModel = {
        contactDetails: {
          emailId,
        },
        type,
      };
    } else if (templateType === OTP_FOR_MOB_CHANGE) {
      const { contactDetails } = submitProfilePayload;
      const { mobileNumber } = contactDetails;
      profileDataModel = {
        contactDetails: {
          mobileNumber,
        },
        type,
      };
    }

    SecureClient({
      isEncrypted: true,
      customerId,
      otherPayloadDetailsPresent: true,
      route: 'dashboardmenus/edit_profile/submit_details',
      payload: {
        customerRefNum,
        profileDataModel,
        profileOtpReqModel: {
          otpCode,
          templateType,
        },
        appId: APP_ID,
        appVersion: APP_VERSION,
      },
      headers: { Authorization },
      method: 'POST',
      successFn: (res) => {
        debug('WATCH', `Response: `, res);
        dispatch({ type: 'SubmitProfile/fulfilled', payload: res });
      },
      errorFn: (err) => {
        debug('ERROR', `Error: `, err);
        dispatch({ type: 'SubmitProfile/rejected', payload: err });
      },
    });
  }
);

export const SubmitProfile_extrareducer = {
  [SubmitProfileDetailsApi.pending]: (state, action) => {
    state.submitProfileDetailsApiState.isLoading = true;
  },
  [SubmitProfileDetailsApi.fulfilled]: (state, action) => {
    state.submitProfileDetailsApiState.isLoading = false;
    state.submitProfileDetailsApiState.isSuccess = true;
    state.submitProfileDetailsApiState.isError = false;
    state.submitProfileDetailsApiState.response = action.payload;
  },
  [SubmitProfileDetailsApi.rejected]: (state, action) => {
    state.submitProfileDetailsApiState.isLoading = false;
    state.submitProfileDetailsApiState.isSuccess = false;
    state.submitProfileDetailsApiState.isError = true;
    state.submitProfileDetailsApiState.response = action.payload;
  },
};
